import Image from 'components/Common/Image/Image'

const SIZE_MAP = {
  width: 348,
  aspectRatio: '2:1',
}

function WineSelectorsLogo() {
  return (
    <Image
      image={{ id: 'wine-selectors-logo' }}
      width={SIZE_MAP.width}
      aspectRatio={SIZE_MAP.aspectRatio}
      gravity="center"
      alt="Wine Selectors Logo"
    />
  )
}

export default WineSelectorsLogo
